import { Flex, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { getCookie, setCookie } from '../../utils/cookies-util';
import { forgotPasswordApi } from '../../api/auth-user-api';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { LoadingOutlined } from '@ant-design/icons';
import { Button } from '../../common';

const ResendLink = ({ email = '', handleSubmit, isSubmitting }) => {
  const [loading, setLoading] = useState(false);
  const resendTime = getCookie('resend-link-time') || new Date().getTime();
  const currentTime = new Date().getTime();

  const timeRemaining = (parseInt(resendTime, 10) - currentTime) / (24 * 60);
  const [timeLeft, setTimeLeft] = useState(parseInt(timeRemaining));

  useEffect(() => {
    if (timeRemaining > 0) {
      setTimeLeft(parseInt(timeRemaining));
    }
  }, []);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const handleResendLink = async () => {
    if (timeLeft > 0 || !email) return;
    setLoading(true);
    try {
      const data = { email };
      const res = await forgotPasswordApi(data);

      if (res && res?.status) {
        toast.success(res?.message || 'Link Sent to provided email address');
        setTimeLeft(res?.reset_password_delay * 60);
        setCookie('resend-link-time', new Date().getTime() + res?.reset_password_delay * 60 * 24 * 60);
      }
    } catch (error) {
      toast.error(getErrorString(error));
    } finally {
      setLoading(false);
    }
  };

  const customIcon = <LoadingOutlined style={{ fontSize: 18, color: 'var(--ant-color-primary)' }} spin />;

  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor((timeLeft % 3600) / 60);
  const seconds = timeLeft % 60;

  const formattedTime =
    hours > 0
      ? `(${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')})`
      : `(${minutes}:${String(seconds).padStart(2, '0')})`;

  if (timeLeft <= 0) {
    return (
      <Button
        className={'h4-medium primary-button'}
        text={'Submit'}
        type="primary"
        size="large"
        onClick={handleSubmit}
        loading={isSubmitting}
      />
    );
  }

  return (
    <Flex vertical gap={10}>
      <Button className={'h4-medium primary-button'} text={'Submit'} type="primary" size="large" disabled />
      <Flex wrap="wrap" justify="center" align="center" gap={8} className="notify-box">
        <div style={{ textAlign: 'center' }}>I didn't recieve the reset link -{timeLeft > 0 && ' Try again after'}</div>
        {loading ? (
          <Spin indicator={customIcon} />
        ) : (
          <div
            //onClick={() => handleResendLink()}
            className="h5-semibold"
            style={{ color: 'var(--ant-color-primary)' }}
          >
            {timeLeft > 0 ? formattedTime : 'Resend Link'}
          </div>
        )}
      </Flex>
    </Flex>
  );
};

export default ResendLink;
